import { gql } from '@grandvisionhq/graphql';
import PersonalDetailsFragment from '../fragments/personal-details.js';

var UPDATE_PERSONAL_DETAILS = gql`
  mutation UpdatePersonalDetails($customerId: ID!, $input: PersonalDetailsB2CUpdateInput!) {
    updateB2CPersonalDetails(customerId: $customerId, input: $input) {
      id
      personalDetails {
        ...PersonalDetailsFragment
      }
      preferredStore {
        globalStoreId
      }
    }
  }
  ${PersonalDetailsFragment}
`;

export { UPDATE_PERSONAL_DETAILS as default };
//# sourceMappingURL=update-personal-details.js.map
